import _styled from '@emotion/styled/base';
import { css } from '@emotion/react';
import { Spacing } from '@tablekit/theme';
import { Typography } from '@tablekit/typography';
import { margin } from '@tablekit/utils';

var ItemGroupContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "edf45wx3"
} : {
  target: "edf45wx3",
  label: "ItemGroupContainer"
})("display:flex;flex-direction:column;min-width:", function (_ref) {
  var minWidth = _ref.minWidth;
  return minWidth || '1px';
}, ";");

var TitleContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "edf45wx2"
} : {
  target: "edf45wx2",
  label: "TitleContainer"
})("margin:", Spacing.L2, " ", Spacing.L2, ";");

var TitleText = _styled("p", process.env.NODE_ENV === "production" ? {
  target: "edf45wx1"
} : {
  target: "edf45wx1",
  label: "TitleText"
})(function (_ref2) {
  var isUppercase = _ref2.isUppercase;
  return isUppercase ? 'text-transform:  uppercase' : '';
}, ";font-weight:600;", Typography.Body2, ";min-width:0;", function (_ref3) {
  var headingStyles = _ref3.headingStyles;
  return headingStyles;
}, ";");

var ItemGroupContent = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "edf45wx0"
} : {
  target: "edf45wx0",
  label: "ItemGroupContent"
})("display:flex;", function (props) {
  var orientation = props.orientation,
      hasIndent = props.hasIndent,
      shouldWrap = props.shouldWrap;
  var isHorizontal = orientation === 'horizontal';
  var flexDirection = isHorizontal ? 'row' : 'column';
  var wrapIndent = parseInt(Spacing.L2, 10) / 2;

  if (shouldWrap) {
    return /*#__PURE__*/css("flex-direction:", flexDirection, ";flex-wrap:wrap;margin:", hasIndent ? "-".concat(wrapIndent, "px") : '', ";&>*{margin:", hasIndent ? "".concat(wrapIndent, "px") : '', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:ItemGroupContent;"));
  }

  if (hasIndent) {
    var lastChildMargin = isHorizontal ? {
      right: Spacing.L2
    } : {
      bottom: Spacing.L2
    };
    return /*#__PURE__*/css("flex-direction:", flexDirection, ";&>*:not(:last-child){", margin(lastChildMargin)(props), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:ItemGroupContent;"));
  }

  return /*#__PURE__*/css("flex-direction:", flexDirection, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ItemGroupContent;"));
}, ";");

export { ItemGroupContainer, ItemGroupContent, TitleContainer, TitleText };
